import { z } from 'zod';

export const SChatwootContact = z.object({
  id: z.number(),
  name: z.string(),
  available_name: z.string().optional(),
  avatar_url: z.string().optional(),
  type: z.string(),
  availability_status: z.string().optional(),
  thumbnail: z.string(),
});
export type TChatwootContact = z.infer<typeof SChatwootContact>;
